module.exports = __webpack_public_path__ + "img/img4.0ac4d905.png";